






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ProductForm from './ProductForm.vue';
import { GET_PRODUCT, UPDATE_PRODUCT } from '@/queries/Product';
import { GQL_updateProduct } from '@/queries/__generated__/updateProduct';
import { InMemoryCache } from 'apollo-cache-inmemory';
import SPopup from '@/components/UI/Popup/SPopup.vue';

@Component({
  components: {
    ProductForm,
  },
})
export default class ProductEdit extends Vue {
  @Prop(String) public id!: string;
  @Prop() private parentPopup!: SPopup
  public GET_PRODUCT = GET_PRODUCT;
  public UPDATE_PRODUCT = UPDATE_PRODUCT;

  @Emit()
  public productUpdated(store: InMemoryCache, query: { data: GQL_updateProduct }) {
    return query.data.updateProduct && query.data.updateProduct.product;
  }
}
